<!-- eslint-disable -->
<template lang="pug">
    .fireworks-wrapper
        .fireworks-canvas(id="fireworks-container")
</template>

<script>
    /*eslint-disable*/
    import * as Fireworks from 'fireworks-canvas'; // mjs
    const fireworksOptions = {
        maxRockets: 16,            // max # of rockets to spawn
        rocketSpawnInterval: 100, // millisends to check if new rockets should spawn
        numParticles: 100,        // number of particles to spawn when rocket explodes (+0-10)
        explosionMinHeight: 0.4,  // percentage. min height at which rockets can explode
        explosionMaxHeight: 1,  // percentage. max height before a particle is exploded
        explosionChance: 0.08     // chance in each tick the rocket will explode
    };

    export default {
        props: {
            isMobile: {
                type: Boolean,
                default: false,
            }
        },
        data () {
            return {
                fireworks: null,
            }
        },
        mounted () {
            this.startFirework();
        },
        beforeDestroy () {
            if (this.fireworks) {
                this.fireworks.kill();
            }
        },
        methods: {
            startFirework () {
                let fireworksContainer = document.getElementById('fireworks-container');
                this.fireworks = new Fireworks(fireworksContainer, fireworksOptions);
                if (this.isMobile) {
                    fireworksContainer.lastChild.height = document.documentElement.clientHeight;
                    fireworksContainer.lastChild.width = document.documentElement.clientWidth;
                    this.fireworks.ch = document.documentElement.clientHeight;
                    this.fireworks.things.ch = document.documentElement.clientHeight;
                    this.fireworks.min_h = document.documentElement.clientHeight;
                }
                this.fireworks.start();
            },
        }
    }
</script>

<style lang="scss" scoped>
    .fireworks-wrapper {
        width: 100%;
        height: calc(100% - 54px);
        pointer-events: none;
        position: absolute;
        top: auto;
        bottom: -16px;
        left: 0;
        right: 0;
        overflow: hidden;
    }

    .fireworks-canvas {
        width: 100%;
        height: 100%;
        vertical-align: middle;
        text-align: center
    }
</style>
